// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var theme = {
    background: "#fbfbfb",
    gray1: "#EDEDED55",
    foreground: "#000"
};
var view = function (props) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Layout")([ inline({
        position: "fixed",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        backgroundColor: theme.background,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }) ]);
    var elMainPanel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("MainPanel")([ inline({
        margin: "1px",
        gridArea: "MainPanel",
        backgroundColor: theme.gray1,
        overflow: "auto",
        border: "1px solid #d8d8d8"
    }) ]);
    var elLoginPanel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("LoginPanel")([ inline({
        gridArea: "LoginPanel",
        backgroundColor: theme.gray1,
        border: "1px solid #d8d8d8"
    }) ]);
    var elHeader = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Header")([ inline({
        gridArea: "Header",
        backgroundColor: theme.gray1,
        border: "1px solid #d8d8d8"
    }) ]);
    var elError = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Error")([ inline({
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        backgroundColor: "#f95b5b",
        color: "white",
        padding: "10px",
        zIndex: "1000"
    }) ]);
    var elEditPanel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("EditPanel")([ inline({
        margin: "1px",
        gridArea: "EditPanel",
        backgroundColor: theme.gray1,
        border: "1px solid #d8d8d8"
    }) ]);
    var elDetailsPanel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanel")([ inline({
        margin: "1px",
        gridArea: "DetailsPanel",
        backgroundColor: theme.gray1,
        border: "1px solid #d8d8d8",
        marginLeft: "10px",
        width: "300px",
        overflow: "auto"
    }) ]);
    var elAppRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("AppRoot")([ inline({
        backgroundColor: theme.background,
        display: "grid",
        maxWidth: "1024px",
        maxHeight: "768px",
        height: "100%",
        width: "100%",
        gridTemplateColumns: "2fr auto",
        gridTemplateRows: "70px 2fr auto",
        gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Header    Header      \"", "\"MainPanel DetailsPanel\"", "\"EditPanel EditPanel   \"" ]),
        gridRowGap: "10px",
        position: "relative"
    }), (function () {
        if (props.showLogin) {
            return inline({
                gridTemplateColumns: "auto",
                gridTemplateRows: "70px auto",
                gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Header   \"", "\"LoginPanel\"" ])
            });
        };
        return inline({
            gridTemplateColumns: "2fr auto",
            gridTemplateRows: "70px 2fr auto",
            gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Header    Header      \"", "\"MainPanel DetailsPanel\"", "\"EditPanel EditPanel   \"" ])
        });
    })() ]);
    return elRoot([  ])([ (function () {
        if (props.showLogin) {
            return elAppRoot([  ])([ elHeader([  ])([ props.headerPanel ]), elLoginPanel([  ])([ props.loginPanel ]) ]);
        };
        return elAppRoot([  ])([ elHeader([  ])([ props.headerPanel ]), elMainPanel([  ])([ props.mainPanel ]), elEditPanel([  ])([ props.editPanel ]), (function () {
            if (props.detailsPanel instanceof Data_Maybe.Just) {
                return elDetailsPanel([  ])([ props.detailsPanel.value0 ]);
            };
            if (props.detailsPanel instanceof Data_Maybe.Nothing) {
                return Halogen_Styled.text("");
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Views.Layout (line 169, column 15 - line 171, column 35): " + [ props.detailsPanel.constructor.name ]);
        })() ]);
    })(), (function () {
        if (props.error instanceof Data_Maybe.Just) {
            return elError([  ])([ props.error.value0 ]);
        };
        if (props.error instanceof Data_Maybe.Nothing) {
            return Halogen_Styled.text("");
        };
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Views.Layout (line 173, column 9 - line 175, column 29): " + [ props.error.constructor.name ]);
    })() ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
